module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MMh6IU/tc-custom/9781429948128.jpg?1737774792390",
      "alt": "This image is the cover for the book An Apprentice to Elves, Iskryne"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("An Apprentice to Elves, Iskryne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("With "), _c('i', [_vm._v("An Apprentice to Elves")]), _vm._v(", Sarah Monette and Elizabeth Bear return with the third book in their epic fantasy series, the Iskryne trilogy"), _c('i', [_vm._v(".")])]), _c('br'), _c('br'), _vm._v(" The trilogy began with "), _c('i', [_vm._v("A Companion to Wolves")]), _vm._v(", and continued in "), _c('i', [_vm._v("The Tempering of Men")]), _vm._v(". This novel picks up the story of Alfgyfa, a young woman who has been raised in the Wolfhall by her father Isolfr, who is the human leader of the queen-wolf Viridechtis' pack, and was the protagonist of the first book."), _c('br'), _c('br'), _vm._v(" The warrior culture of Iskryne forbids many things to women—and most especially it forbids them bonding to one of the giant telepathic trelwolves. But as her father was no ordinary boy, Alfgyfa is no ordinary girl. Her father has long planned to send his daughter to Tin, a matriarch among the elves who live nearby, to be both apprentice and ambassador, and now she is of age to go. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Monette, Elizabeth Bear\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0